
<template>
  <vs-row class="my-5">
    <vs-col>
      <h6 class="font-bold mb-4">{{ $t('filters.' + filter.title + '.title') }}</h6>
      <div>
        <ul>
          <li v-for="(term, index) in filter.terms" :key="index" class="mb-2 flex items-center justify-between">
            <vs-checkbox color="success"
                         v-model="selected"
                         :vs-value="term.value">
              <span v-if="term.translate" :class="{'text-success':isSelected(term)}">{{$t('filters.' + filter.title + '.values.' + term.label)}}</span>
              <span v-else :class="{'text-success':isSelected(term)}">{{term.label}}</span>
            </vs-checkbox>
            <span>{{ term.count }}</span>
          </li>
        </ul>
      </div>
    </vs-col>
  </vs-row>
</template>

<script>


export default {
  name: 'sm-hateoas-filter-terms',
  props: {
    filter: {
      type: Object,
      default () {
        return {
          id: null,
          title: null,
          terms: []
        };
      }
    }
  },
  data () {
    return {
      selected: this.filter.terms.filter(t => t.selected).map(t => t.value)
    };
  },
  watch: {
    selected: {
      immediate: true,
      handler (value) {
        this.$emit('change', value);
      }
    }
  },
  methods: {
    isSelected (term) {
      return this.selected.indexOf(term.value) >= 0;
    }
  }
};
</script>

<style scoped>

</style>
